/** /managerDashboard/stats/event-totals
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20EventTotalsResponseDto
 */
export const getEventTotalsRespAviation = () => {
  return {
    countEvents: {
      preSignol: 12312,
      postSignol: 31932,
    },
    countOperators: 597,
    countOperatorUsers: 266,
  };
};
